import { render, staticRenderFns } from "./quantity.vue?vue&type=template&id=00bbc65a&scoped=true&"
import script from "./quantity.vue?vue&type=script&lang=js&"
export * from "./quantity.vue?vue&type=script&lang=js&"
import style0 from "./quantity.vue?vue&type=style&index=0&id=00bbc65a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bbc65a",
  null
  
)

export default component.exports